import React, { useEffect, useState } from "react";
import Breakpoint, { BreakpointProvider, setDefaultBreakpoints } from "react-socks";
import { NavLink } from 'react-router-dom'; // eslint-disable-line no-unused-vars
import useOnclickOutside from "react-cool-onclickoutside";


setDefaultBreakpoints([
  { xs: 0 },
  { l: 1199 },
  { xl: 1200 }
]);

const StyledNavLink = (props) => (
  <NavLink {...props} className={({ isActive }) => isActive ? 'active' : 'non-active'} />
);

// Type writer effect
const useTypewriter = (words, speed = 50, delayBetweenWords = 1000) => {
  const [displayText, setDisplayText] = useState('');
  const [wordIndex, setWordIndex] = useState(0);

  useEffect(() => {
    if (!words || words.length === 0) return; // Early return if `words` is undefined or empty
    const currentWord = words[wordIndex];
    let i = 0;
    setDisplayText('');

    const typingInterval = setInterval(() => {
      if (i < currentWord.length) {
        setDisplayText(prevText => prevText + currentWord.charAt(i));
        i++;
      } else {
        clearInterval(typingInterval);
        setTimeout(() => {
          setWordIndex(prevIndex => (prevIndex + 1) % words.length);
        }, delayBetweenWords);
      }
    }, speed);

    return () => {
      clearInterval(typingInterval);
    };
  }, [wordIndex, words, speed, delayBetweenWords]);

  return displayText;
};

const words = ['Contact', 'Volunteer', 'Sponsor'];

const Typewriter = ({ words, speed }) => {
  const displayText = useTypewriter(words, speed);
  return <>{displayText}</>;
};



export default function() {

    const [, setOpenMenu] = React.useState(false);
    const [, ] = React.useState(false);
    const closeMenu = () => {
      setOpenMenu(false);
    };
    const ref = useOnclickOutside(() => {
      closeMenu();
    });

    const [showmenu, btn_icon] = useState(false);
    useEffect(() => {
    const header = document.getElementById("myHeader");
    const sticky = header.offsetTop;
    const scrollCallBack = window.addEventListener("scroll", () => {
        btn_icon(false);
        if (window.pageYOffset > sticky + 300) {
          header.classList.add("sticky");
          
        } else {
          header.classList.remove("sticky");
        } if (window.pageYOffset > sticky) {
          closeMenu();
        }
      });
      return () => {
        window.removeEventListener("scroll", scrollCallBack);
      };
    }, []);
    return (
    <header id="myHeader" className='navbar'>
     <div className='container-fluid'>
       <div className='row m-2-hor w-100-nav'>
          <div className='logo'>
              <div className='navbar-title navbar-item'>
                <StyledNavLink to="/">
                <img
                    src="/img/logo_t_light.png"
                    className="img-fluid"
                    alt="#"
                  />
                </StyledNavLink>
              </div>
          </div>
                    
              <BreakpointProvider>
                <Breakpoint l down>
                  {showmenu && 
                  <div className='menu'>
                    <div className='navbar-item'>
                      <div ref={ref}>
                        <StyledNavLink to="/" onClick={() => btn_icon(!showmenu)}>
                          Home
                        </StyledNavLink>
                      </div>
                    </div>
                    <div className='navbar-item'>
                      <StyledNavLink to="/about" onClick={() => btn_icon(!showmenu)}>
                        About Us
                      </StyledNavLink>
                    </div>
                    <div className='navbar-item'>
                      <StyledNavLink to="/team" onClick={() => btn_icon(!showmenu)}>
                        Team
                      </StyledNavLink>
                    </div>
                    <div className='navbar-item'>
                      <StyledNavLink to="/events" onClick={() => btn_icon(!showmenu)}>
                        Events
                      </StyledNavLink>
                    </div>
                    <div className='navbar-item'>
                      <StyledNavLink to="/projects" onClick={() => btn_icon(!showmenu)}>
                        Projects
                      </StyledNavLink>
                    </div>
                    <div className='navbar-item'>
                      <StyledNavLink to="/shop" onClick={() => btn_icon(!showmenu)}>
                        Shop
                      </StyledNavLink>
                    </div>
                    <div className='navbar-item'>
                      <StyledNavLink to="/jobs" onClick={() => btn_icon(!showmenu)}>
                        Jobs
                      </StyledNavLink>
                    </div>
                    <div className='navbar-item'>
                      <StyledNavLink to="/contact" onClick={() => btn_icon(!showmenu)}>
                        <Typewriter words={words} speed={100} />
                      </StyledNavLink>
                    </div>
                    <div className='navbar-item'>
                      <StyledNavLink to="/donate" onClick={() => btn_icon(!showmenu)}>
                        Donate
                      </StyledNavLink>
                    </div>
                  </div>
                  }
                </Breakpoint>

                <Breakpoint xl>
                  <div className='menu'>
                    <div className='navbar-item'>
                        <div ref={ref}>
                          <StyledNavLink to="/">
                            Home
                          </StyledNavLink>
                        </div>
                    </div>
                    <div className='navbar-item'>
                      <StyledNavLink to="/about">About Us</StyledNavLink>
                    </div>
                    <div className='navbar-item'>
                      <StyledNavLink to="/team">Team</StyledNavLink>
                    </div>
                    <div className='navbar-item'>
                      <StyledNavLink to="/events">Events</StyledNavLink>
                    </div>
                    <div className='navbar-item'>
                      <StyledNavLink to="/projects">Projects</StyledNavLink>
                    </div>
                    <div className='navbar-item'>
                      <StyledNavLink to="/shop">Shop</StyledNavLink>
                    </div>
                    <div className='navbar-item' style={{ paddingRight: '20px' }}>
                      <StyledNavLink to="/jobs">Jobs</StyledNavLink>
                    </div>
                    <div className='navbar-item'>
                      <StyledNavLink to="/contact">
                        <span className="contact-button" role="button"><Typewriter words={words} speed={100} /></span>
                      </StyledNavLink>
                    </div>
                    <div className='navbar-item'>
                      <StyledNavLink to="/donate">
                        <span className="donate-button" role="button">Donate</span>
                      </StyledNavLink>
                    </div>
                  </div>
                </Breakpoint>
              </BreakpointProvider>
                  
      </div>

        <button className="nav-icon" onClick={() => btn_icon(!showmenu)}>
          <div className="menu-line white"></div>
          <div className="menu-line1 white"></div>
          <div className="menu-line2 white"></div>
        </button>

      </div>     
    </header>
    );
}
